/**
 * RS / Our Mission — the tree grows once.
 *
 * The growth is pure CSS (stroke-dashoffset transitions keyed on `is-grown`);
 * this element only adds the class the first time the section enters the
 * viewport, then unobserves. Reduced motion: the tree is drawn from the start
 * (handled in CSS), no class needed.
 */
class RsMission extends HTMLElement {
  #observer = null;

  connectedCallback() {

    this.#observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          this.classList.add('is-grown');
          this.#observer.unobserve(this);
        }
      },
      { threshold: 0.2 }
    );
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('rs-mission')) {
  customElements.define('rs-mission', RsMission);
}
